import { Accordion } from '@design/components/accordion/Accordion';
import styles from '@terminal/components/citations-section/CitationsSection.module.scss';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { DocumentsRow } from './documents-row/DocumentsRow';

export interface DocumentsSectionProps {
  title: string;
  count: number;
  items: { id: string; name: string }[];
}

export const DocumentsSection = ({
  title,
  count,
  items,
}: DocumentsSectionProps) => {
  const { t } = useTranslation(['earnings']);

  const accordionItems = [
    {
      title: (
        <div className={styles.titleContainer}>
          <span className={styles.titleLabel}>{title}</span>
          <span className={styles.countLabel}>
            {t('earnings:earningsInsight.drawer.count', { count })}
          </span>
        </div>
      ),
      content: items.map(item => (
        <div className={styles.itemContainer} key={item.id}>
          <DocumentsRow id={item.id} name={item.name} />
        </div>
      )),
      expandedByDefault: true,
    },
  ];
  return (
    <Accordion className={styles.styledAccordion} items={accordionItems} />
  );
};
